<template>
<div id="list-demande_creation-four" class="data-list-container">
    <vs-table :key="updateView" ref="table" v-model="infoFournissseur" pagination :max-items="itemsPerPage" search :data="dataList">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <!-- ACTION - DROPDOWN -->

            </div>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ dataList.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : dataList.length }} of {{ queriedItems }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=7">
                        <span>7</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=25">
                        <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=35">
                        <span>35</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <template slot="thead">
            <vs-th sort-key="Item_No" class="table_head_color">Matricule Fiscale</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Raison Sociale</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Téléphone</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Email</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Type</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Etat</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Actions</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].matriculeFisc">
                        <p class="product-name font-medium truncate">{{ tr.matriculeFisc }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.raisonSociale }} </p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.telephoneFixe }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.email }}</p>
                    </vs-td>
                    <vs-td>
                        <p>{{ tr.typeAchat }}</p>
                    </vs-td>

                    <vs-td>
                        <p v-if="tr.etat">Traité</p>
                        <p v-else>Non Traité</p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->

                        <feather-icon icon="EyeIcon" color="primary" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="showDetails(tr)" />
                        <feather-icon icon="PrinterIcon" color="primary" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click.stop="$refs.pdfFicheSign.print()" class="ml-2" />

                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>

    <vs-popup fullscreen title="Fiche Signalitique Fournisseur" :active.sync="popupActive" v-show="popupActive" :key="updateFicheFournisseur">
        <div class="vx-card md:m-5">
            <div class="vx-card__header">
                <div class="vx-card__title">
                    <h4 class>Coordonnées</h4>
                </div>
            </div>

            <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                    <!-- Content Row -->
                    <div class="w-full">
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Raison Sociale</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.raisonSociale" readonly class="w-full" icon-pack="feather" v-validate="'required'" icon="icon-edit" name="raisonSociale" />

                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Matricule Fiscale</label>

                                    <div class="mt-2">
                                        <vs-input class="w-full" v-model="infoFournissseur.matriculeFisc" readonly icon-pack="feather" icon="icon-edit" v-validate="'required'" name="matriculeFisc" />

                                    </div>
                                </div>
                            </div>

                            <!-- Save & Reset Button -->
                        </div>
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Code Fournisseur</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.codeFournisseur" class="w-full" readonly icon-pack="feather" icon="icon-edit" name="codeFournisseur" />

                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Importé/Local</label>

                                    <div class="mt-1 vx-row">
                                        <div class="mt-2">
                                            <vs-checkbox v-model="infoFournissseur.Local" readonly>Importé</vs-checkbox>
                                        </div>
                                        <div class="mt-2">
                                            <vs-checkbox v-model="infoFournissseur.importee" readonly>Local</vs-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Adresse</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.adresse" class="w-full" readonly icon-pack="feather" icon="icon-map-pin" />
                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Code Postale</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.codePostale" class="w-full" readonly icon-pack="feather" icon="icon-edit" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Ville</label>

                                    <div class="mt-2">
                                        <vs-input class="w-full" v-model="infoFournissseur.ville" readonly icon-pack="feather" icon="icon-edit" />
                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Gouvernorat</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.grouvernorat" class="w-full" readonly icon-pack="feather" icon="icon-edit" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>
        <div class="vx-card md:m-5">

            <div class="vx-card__header">
                <div class="vx-card__title">
                    <h4 class>Communication</h4>
                </div>
            </div>

            <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                    <!-- Content Row -->
                    <div class="w-full">
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Télephone Fixe N°</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.telephoneFixe" class="w-full" icon-pack="feather" icon="icon-phone" name="telephoneFixe" />
                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Fax N°</label>

                                    <div class="mt-2">
                                        <vs-input class="w-full" v-model="infoFournissseur.fax" icon-pack="feather" icon="icon-clock" v-validate="'required'" name="fax" />
                                    </div>
                                </div>
                            </div>

                            <!-- Save & Reset Button -->
                        </div>
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Email </label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.email" class="w-full" icon-pack="feather" icon="icon-edit" name="email" />
                                        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Mobile N° </label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.telephoneMobile" class="w-full" icon-pack="feather" icon="icon-phone" name="telephoneMobile" />
                                        <span class="text-danger text-sm" v-show="errors.has('telephoneMobile')">{{ errors.first('telephoneMobile') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Web</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.web" class="w-full" icon-pack="feather" icon="icon-web" />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </div>
        <div class="vx-card md:m-5">
            <div class="vx-card__header">
                <div class="vx-card__title">
                    <h4 class>Facturation</h4>
                </div>
            </div>

            <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                    <!-- Content Row -->
                    <div class="w-full">
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Marge</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.marge" class="w-full" icon-pack="feather" icon="icon-edit" name="code" />
                                        <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first('code') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Remise</label>

                                    <div class="mt-2">
                                        <vs-input class="w-full" v-model="infoFournissseur.remise" icon-pack="feather" icon="icon-edit" v-validate="'required'" name="designation" />
                                        <span class="text-danger text-sm" v-show="errors.has('designation')">{{ errors.first('designation') }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Save & Reset Button -->
                        </div>

                    </div>

                </div>
            </div>

            <div class="vx-card__header">
                <div class="vx-card__title">
                    <h4 class>Paiement</h4>
                </div>
            </div>

            <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                    <!-- Content Row -->
                    <div class="w-full">

                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">ConditionPaiement / Délais</label>

                                    <div class="mt-2">
                                        <vs-input class="w-full" v-model="infoFournissseur.delaisPaiment" />
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary  px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Mode de Réglement/paiement</label>
                                    <div class="mt-2 vx-col">

                                        <div class="mt-2">
                                            <vs-checkbox v-model="infoFournissseur.modePaiCheque">Chèque</vs-checkbox>
                                        </div>
                                        <div class="mt-2">
                                            <vs-checkbox v-model="infoFournissseur.modePaiTraite">Traite</vs-checkbox>

                                        </div>
                                        <div class="mt-2 vx-col">
                                            <label class="ml-2">Autre</label>
                                            <vs-input v-model="infoFournissseur.modePaiAutre" icon-pack="feather" icon="icon-edit" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="flex mb-4 vx-col md:w-full">
                            <div class="vx-col md:w-1/6"></div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
        <div class="vx-card md:m-5">
            <div class="vx-card__header">
                <div class="vx-card__title">
                    <h4 class>Achats</h4>
                </div>
            </div>

            <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                    <!-- Content Row -->
                    <div class="w-full">
                        <div class="flex mb-4 vx-col md:w-full ">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Type</label>

                                    <div class="mt-2">
                                        <vs-input class="w-full" v-model="infoFournissseur.typeAchat" v-validate="'required'" />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>

            <div class="vx-card__header">
                <div class="vx-card__title">
                    <h4 class>Logistique</h4>
                </div>
            </div>

            <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-card__body">
                    <!-- Content Row -->
                    <div class="w-full">
                        <div class="flex mb-4 vx-col md:w-full ">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Livraison</label>

                                    <div class="mt-1 vx-row">
                                        <div class="mt-2">
                                            <vs-checkbox v-model="infoFournissseur.collecte">collecte</vs-checkbox>
                                        </div>
                                        <div class="mt-2">
                                            <vs-checkbox v-model="infoFournissseur.LivraisonFournisseur">Fournisseur</vs-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Délai de Livraison</label>

                                    <div class="mt-2">
                                        <vs-input v-model="infoFournissseur.delaiLivraison" icon-pack="feather" icon="icon-edit" />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="flex mb-6 mt-10 vx-col md:w-full ">
                            <div class="vx-col md:w-1/6"></div>
                            <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                                <div class="w-full mt-1">
                                    <label class="block text-gray-700 text-sm font-bold">Pièce Jointe ...</label>

                                    <div class="mt-1 vx-row" v-for="file in infoFournissseur.urlFiles" :key="file.id">
                                        <a :href="dowloadUrlFile(file.id)" icon-pack="feather" icon="icon-edit">{{file.name}}</a>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </vs-popup>
    <pdf :key="keypdfupdate" ref="pdfFicheSign" :src="baseUrl"></pdf>
</div>
</template>

<script>
import pdf from "vue-pdf";
import indexfour from "@/http/requests/fournisseur/index.js";
import {
    axiosConfig
} from "@/axios.js";
export default {
    components: {
        pdf
    },
    data() {
        return {
            showpdf: false,
            filedata: 'data:',
            lasttype: '',
            itemsPerPage: 10,
            currentPage: 1,
            active: false,
            dialog: false,
            popupActiAdd: false,
            updateView: 0,
            colorx: this.$store.state.themePrimaryColor,
            popupActive: false,
            showdata: false,
            infoFournissseur: {},
            dataList: [],
            queriedItems: 0,
            keypdfupdate: 0,
            updateFicheFournisseur: 524,
            cellAutoWidth: true,
            headerTitle: [
                "N° Client",
                "Nom",
                "Telephone",
                "Email",
                "Adresse",
                "Magasin"
            ],
            headerVal: [
                "No",
                "Name",
                "Phone_No",
                "E_Mail",
                "Address",
                "Location_code"
            ],
            imgView: require("@/assets/images/portrait/small/eye.svg"),

        };
    },
    watch: {
        dataList: function (val) {
            if (val.length >= 0) {
                this.$vs.loading.close("#list-demande_creation-four  > .con-vs-loading");
            }
        },
        infoFournissseur: function (val) {
            if (val.id != null) {
                this.keypdfupdate += 4758;
            }
        }
    },
    computed: {
        baseUrl() {
            console.log(axiosConfig.baseURL +
                "/fournisseurs/demandecreation/print/" +
                this.infoFournissseur.id)
            return axiosConfig.baseURL +
                "/fournisseurs/demandecreation/print/28";

        },
        selectedfullName: function () {
            return this.selected.client.nom + ' ' + this.selected.client.prenom
        },
        responseReadOnly: function () {
            return this.selected.etat
        },
        srcfile: function () {
            return this.data + this.lasttype;
        },

    },
    methods: {
        dowloadUrlFile(idfile) {
            return axiosConfig.baseURL + "/files/download/" + idfile
        },
        getPieceJointeFciheSignalitique() {
            this.$vs.loading();
             
            indexfour.gteFilesByContexteAndCreePar('Demande Creation Fournisseur', this.infoFournissseur.matriculeFisc).then(response => {
                this.infoFournissseur.urlFiles = response.data
                this.$vs.loading.close();
                this.popupActive = true
            }).catch(error => {
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur Lors de chargement de piece jointe ",
                    text: error.response.data,
                    color: "primary",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
                this.popupActive = true
            });

        },
        envoiReponse() {

            this.$vs.dialog({
                type: "confirm",
                color: "warning",
                title: `Activer Compte`,
                text: "Confirmer l'envoi de message ? ",
                acceptText: "Activer",
                cancelText: "Annuler",
                accept: this.confirmEnvoiResponse
            });
        },
        /*    confirmEnvoiResponse() {
               ReclammationServ.AddResponse(this.selected.id, this.selected.reponse).then(() => {
                   this.selected.etat = true
                   const index = this.dataList.findIndex((p) => p.id == this.selected.id)
                   this.dataList[index] = this.selectedClient
                   this.popupActive = false
                   this.$vs.notify({
                       time: 10000,
                       title: "Envoi avec succes ",
                       text: "",
                       color: "primary",
                       iconPack: "feather",
                       icon: "icon-alert-circles"
                   });
               }).catch(erreur => {
                   this.popupActive = false
                   this.$vs.notify({
                       time: 10000,
                       title: "Erreur s'est produite : ",
                       text: erreur.response.data,
                       color: "danger",
                       iconPack: "feather",
                       icon: "icon-alert-circles"
                   });
               })
           }, */
        showDetails(tr) {
            this.infoFournissseur = tr

            this.getPieceJointeFciheSignalitique()

        },

        downloadfile(id) {

            indexfour.getFilesById(id);
        },
        loadData() {
            try {
                indexfour.getAllDemandeCompteforAdmin().then(response => {
                    console.log(response)
                    this.dataList = response.data
                })
                this.updateView += 1
                this.$vs.loading.close("#list-demande_creation-four  > .con-vs-loading");
            } catch {
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        }
    },

    created() {

        if (this.$store.state.AppActiveUser.id != '') {

            this.loadData();
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "UPDATE_USER_INFO") {
                    this.loadData();
                }
            });
        }
    },
    mounted() {

    }
};
</script>

<style lang="scss">
#list-demande_creation-four {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
